import { onlineApplicationsStarsConst } from "@/src/constants/applicationOnlineConsts";

type ApplicationStar = (typeof onlineApplicationsStarsConst)[number];

const toCamelCase = (value: string) => value.replace(/_([a-z])/g, (_, char: string) => char.toUpperCase());

export const resolveApplicationStar = (colorStar: string | null | undefined): ApplicationStar => {
  const normalized = String(colorStar ?? "default").trim();
  if (!normalized) {
    return onlineApplicationsStarsConst.find((star) => star.color === "default") ?? onlineApplicationsStarsConst[0];
  }

  const direct = onlineApplicationsStarsConst.find((star) => star.color === normalized);
  if (direct) return direct;

  const caseInsensitive = onlineApplicationsStarsConst.find(
    (star) => star.color.toLowerCase() === normalized.toLowerCase(),
  );
  if (caseInsensitive) return caseInsensitive;

  const camelCase = toCamelCase(normalized);
  const fromSnake = onlineApplicationsStarsConst.find((star) => star.color === camelCase);
  if (fromSnake) return fromSnake;

  return onlineApplicationsStarsConst.find((star) => star.color === "default") ?? onlineApplicationsStarsConst[0];
};
